module.exports = __webpack_public_path__ + "static/media/ouest-france-logo.4a7233f4.jpg";